import axios from "axios";
import heic2any from "heic2any";
import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import ReactQuill from "react-quill";

const AddCustomProductModal = ({
  isOpen,
  onClose,
  onAddProduct,
  orderId,
  setCode,
}) => {
  const [activeTab, setActiveTab] = useState(1);

  const [title, setTitle] = useState("");

  const [purchasePricing, setPurchasePricing] = useState("");
  const [flatFeePricing, setFlatFeePricing] = useState("");
  const [HourTime, setHourTime] = useState("");
  const [quantity, setQuantity] = useState("");
  const [description, setdescription] = useState("");
  const [contractDescription, setContractDescription] = useState("");
  const [internalNotes, setInternalNotes] = useState("");
  const [images, setImages] = useState([]); // For multiple images
  const [singleImage, setSingleImage] = useState(null); // For single image
  const [video, setVideo] = useState(null);
  const [model, setModel] = useState(""); // For model field
  const [categories, setCategories] = useState([]); // To store categories from API
  const [EventData, setEventData] = useState([]); // To store EventData from API
  const [selectedCategory, setSelectedCategory] = useState(""); // To store selected category
  const [selectedEvent, setSelectedEvent] = useState(""); // To store selected Event
  const [color, setColor] = useState(""); // To store selected Event
  const [height, setHeight] = useState(""); // For the numeric value of the height
  const [selectedPricingValue, setselectedPricingValue] = useState(""); // For the numeric value of the height
  const [length, setLength] = useState(""); // For the numeric value of the height
  const [width, setWidth] = useState(""); // For the numeric value of the height
  const [unit, setUnit] = useState("ft");
  const [lengthUnit, setLengthUnit] = useState("");
  const [widthUnit, setWidthUnit] = useState("");
  const [shape, setShape] = useState("");
  const [showWebsite, setShowWebsite] = useState(false);
  const [productCode, setProductCode] = useState("");
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  const modules = {
    toolbar: [
      [{ 'header': [1, 2, false] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{'list': 'ordered'}, {'list': 'bullet'}],
      ['link', 'image'],
      ['clean']
    ],
  };

  const formats = [
    'header',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet',
    'link', 'image'
  ];

  // Fetch categories and EventData on component mount
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(
          "https://server-gs.vercel.app/category"
        );
        setCategories(response.data); // Assuming the data is an array of categories
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    const fetchEventData = async () => {
      try {
        const response = await axios.get(
          "https://server-gs.vercel.app/eventCollection"
        );
        setEventData(response.data); // Assuming the data is an array of EventData
      } catch (error) {
        console.error("Error fetching EventData:", error);
      }
    };

    fetchCategories();
    fetchEventData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://server-gs.vercel.app/event-company-tax-value"
        );
        setData(response.data);
        setError(null);
      } catch (err) {
        setError(err.message || "Something went wrong");
      }
    };

    const intervalId = setInterval(fetchData, 1000);
    return () => clearInterval(intervalId);
  }, []);

  // Handle image selection
  const handleImageChange = (e) => {
    setImages([...e.target.files]); // Multiple images
  };

  const [isLoading, setIsLoading] = useState(false);
  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const formData = new FormData();

    // Append all product details to formData
    formData.append("title", title);
    formData.append("quantity", quantity);
    formData.append("purchasePricing", purchasePricing);
    formData.append("flatFeePricing", flatFeePricing);
    formData.append("contractDescription", contractDescription);
    formData.append("description", description);
    formData.append("internalNotes", internalNotes);
    formData.append("model", model);
    formData.append("selectedPricingValue", selectedPricingValue);
    formData.append("perDayPricing", selectedPricingValue);
    formData.append("showWebsite", showWebsite);
    formData.append("category", selectedCategory);
    formData.append("Event", selectedEvent);
    formData.append("height", `${height} ${unit}`);
    formData.append("length", `${length} ${lengthUnit}`);
    formData.append("width", `${width} ${widthUnit}`);
    formData.append("color", color);
    formData.append("shape", shape);
    formData.append("productCode", productCode);

    // Ensure tax value is not undefined or null
    const taxValue = data?.taxValue || 0; // Default to 0 if taxValue is undefined or null
    formData.append("tax", taxValue);

    // Append images, single image, and video
    images.forEach((image) => {
      formData.append("images", image);
    });
    if (singleImage) {
      formData.append("singleImage", singleImage);
    }
    if (video) {
      formData.append("video", video);
    }

    try {
      // Call the onAddProduct function with orderId, setCode, and formData
      await onAddProduct(setCode, formData);
    } catch (error) {
      toast.error("Error adding product.");
    } finally {
      setIsLoading(false);
    }
  };

  // Function to handle tab switching
  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  const [isDragging, setIsDragging] = useState(false);
  const [isDraggingImages, setIsDraggingImages] = useState(false);
  const [isLoadingSingleImage, setIsLoadingSingleImage] = useState(false); // Loading state for single image
  const [isLoadingImages, setIsLoadingImages] = useState(false); // Loading state for multiple images

  // Handle drag over for single image
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  // Handle drag leave for single image
  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  // Handle file drop for single image
  const handleDrop = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const file = e.dataTransfer.files[0];
      await handleFile(file, setIsLoadingSingleImage, setSingleImage); // Handle the file (convert if necessary)
      e.dataTransfer.clearData();
    }
  };

  // Handle file selection for single image
  const handleFileChange = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      await handleFile(file, setIsLoadingSingleImage, setSingleImage); // Handle the file (convert if necessary)
    }
  };

  // Handle file processing (single or multiple)
  const handleFile = async (file, setIsLoading, setImageState) => {
    setIsLoading(true); // Start loading

    try {
      // Check if the file is HEIC/HEIF
      if (
        file.name.toLowerCase().endsWith(".heic") ||
        file.name.toLowerCase().endsWith(".heif")
      ) {
        // Convert HEIC to JPEG
        const convertedBlob = await heic2any({
          blob: file,
          toType: "image/jpeg",
          quality: 0.8, // Adjust quality as needed
        });

        // Create a new File object with the converted blob
        const convertedFile = new File(
          [convertedBlob],
          file.name.replace(/\.heic$|\.heif$/i, ".jpeg"),
          {
            type: "image/jpeg",
          }
        );

        setImageState(convertedFile);
      } else {
        // If it's not HEIC, use the file as-is
        setImageState(file);
      }
    } catch (error) {
      console.error("Error processing file:", error);
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  // Handle file drop for multiple images
  const handleDropImages = async (e) => {
    e.preventDefault();
    setIsDraggingImages(false);

    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      setIsLoadingImages(true); // Start loading

      const files = Array.from(e.dataTransfer.files);
      const convertedFiles = await Promise.all(
        files.map(async (file) => {
          if (
            file.name.toLowerCase().endsWith(".heic") ||
            file.name.toLowerCase().endsWith(".heif")
          ) {
            // Convert HEIC to JPEG
            const convertedBlob = await heic2any({
              blob: file,
              toType: "image/jpeg",
              quality: 0.8, // Adjust quality as needed
            });
            return new File(
              [convertedBlob],
              file.name.replace(/\.heic$|\.heif$/i, ".jpeg"),
              {
                type: "image/jpeg",
              }
            );
          }
          return file;
        })
      );

      setImages((prevImages) => [...prevImages, ...convertedFiles]);
      setIsLoadingImages(false); // Stop loading
    }
  };

  // Handle drag over for multiple images
  const handleDragOverImages = (e) => {
    e.preventDefault();
    setIsDraggingImages(true);
  };

  // Handle drag leave for multiple images
  const handleDragLeaveImages = () => {
    setIsDraggingImages(false);
  };

  // Remove an image from the multiple images list
  const removeImage = (index) => {
    setImages((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex justify-center z-50 items-center font-roboto ">
      <div className="bg-gray-100 rounded-2xl shadow-2xl z-40  w-[80%] placeholder: transform transition-all duration-300 ease-in-out hover:scale-101">
        {/* Header */}
        <div className="flex flex-row justify-between items-center px-6 py-4 bg-gradient-to-r bg-blue-600 rounded-t-2xl">
          <h2 className="text-xl font-bold text-white">Add Custom Product</h2>
          <button
            onClick={onClose}
            className="p-2 rounded-full hover:bg-blue-700 transition-colors duration-200"
          >
            <img
              className="w-4 h-4"
              alt="Close"
              src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgMzI5LjI2OSAzMjkiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTIiIHhtbDpzcGFjZT0icHJlc2VydmUiIGNsYXNzPSIiPjxnPjxwYXRoIGQ9Ik0xOTQuOCAxNjQuNzcgMzIzLjAxMyAzNi41NTVjOC4zNDMtOC4zNCA4LjM0My0yMS44MjUgMC0zMC4xNjQtOC4zNC04LjM0LTIxLjgyNS04LjM0LTMwLjE2NCAwTDE2NC42MzMgMTM0LjYwNSAzNi40MjIgNi4zOTFjLTguMzQ0LTguMzQtMjEuODI0LTguMzQtMzAuMTY0IDAtOC4zNDQgOC4zNC04LjM0NCAyMS44MjQgMCAzMC4xNjRsMTI4LjIxIDEyOC4yMTVMNi4yNTkgMjkyLjk4NGMtOC4zNDQgOC4zNC04LjM0NCAyMS44MjUgMCAzMC4xNjRhMjEuMjY2IDIxLjI2NiAwIDAgMCAxNS4wODIgNi4yNWM1LjQ2IDAgMTAuOTIyLTIuMDkgMTUuMDgyLTYuMjVsMTI4LjIxLTEyOC4yMTQgMTI4LjIxNiAxMjguMjE0YTIxLjI3MyAyMS4yNzMgMCAwIDAgMTUuMDgyIDYuMjVjNS40NiAwIDEwLjkyMi0yLjA5IDE5LjA4Mi02LjI1IDguMzQzLTguMzQgOC4zNDMtMjEuODI0IDAtMzAuMTY0em0wIDAiIGZpbGw9IiNmZmZmZmYiIG9wYWNpdHk9IjEiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiIGNsYXNzPSIiPjwvcGF0aD48L2c+PC9zdmc+"
            />
          </button>
        </div>

        <div className="">
        <form
  className="w-[95%] mx-auto h-[700px] overflow-auto rounded-lg shadow-sm"
  onSubmit={handleSubmit}
  encType="multipart/form-data"
>
  {/* Main Form Content */}
  <div className="p-6 space-y-6">
   

    {/* Quantity & Pricing Row */}
    <div className="grid grid-cols-3 gap-4 sm:grid-cols-3">
       {/* Title Field */}
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">Title *</label>
      <input
        type="text"
        value={title}
        className="block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
        onChange={(e) => setTitle(e.target.value)}
        required
        placeholder="Enter product title"
      />
    </div>
      {/* Quantity Field */}
      <div className="space-y-2">
        <label className="block text-sm font-medium text-gray-700">
          Quantity *
        </label>
        <input
          type="number"
          value={quantity ?? ""}
          className="block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          onChange={(e) => {
            const value = e.target.value;
            if (value === "") {
              setQuantity(null);
              return;
            }
            const parsedValue = parseInt(value, 10);
            if (!isNaN(parsedValue)) {
              setQuantity(parsedValue);
            }
          }}
          required
          placeholder="0"
          min="0"
        />
      </div>

      {/* Pricing Field */}
      <div className="space-y-2">
        <label className="block text-sm font-medium text-gray-700">
          Per Day Pricing
        </label>
        <div className="relative rounded-md shadow-sm">
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
            <span className="text-gray-500 sm:text-sm">$</span>
          </div>
          <input
            type="number"
            value={selectedPricingValue ?? ""}
            className="block w-full pl-7 pr-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            onChange={(e) => {
              const value = e.target.value;
              if (value === "") {
                setselectedPricingValue(null);
                return;
              }
              const parsedValue = parseFloat(value);
              if (!isNaN(parsedValue)) {
                setselectedPricingValue(parsedValue);
              }
            }}
            placeholder="0.00"
            min="0"
            step="0.01"
          />
        </div>
      </div>
    </div>

    {/* Description & Notes Row */}
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-2">
      {/* Description Field */}
      <div className="space-y-2">
        <label className="block text-sm font-medium text-gray-700">
          Product Description
        </label>
        <div className="h-44 bg-white rounded-md border border-gray-300">
          <ReactQuill
            value={description}
            onChange={setdescription}
            modules={modules}
            formats={formats}
            className="h-28" // Adjusted height to fit container
            theme="snow"
          />
        </div>
      </div>

      {/* Internal Notes Field */}
      <div className="space-y-2">
        <label className="block text-sm font-medium text-gray-700">
          Internal Notes
        </label>
        <textarea
          value={internalNotes}
          onChange={(e) => setInternalNotes(e.target.value)}
          className="block w-full h-44 px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          placeholder="Add internal notes (optional)"
        />
      </div>
    </div>

    {/* Image Upload Section */}
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">
        Upload Single Image
      </label>
      <div
        className={`px-6 py-12 border-2 border-dashed rounded-lg text-center transition-colors duration-300 ease-in-out ${
          isDragging
            ? "border-blue-500 bg-blue-50"
            : "border-gray-300 bg-gray-50"
        } hover:border-blue-400 focus-within:border-blue-500`}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        {isLoadingSingleImage ? (
          <div className="flex flex-col items-center">
            <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mb-4"></div>
            <p className="text-sm text-gray-500">Processing image...</p>
          </div>
        ) : singleImage ? (
          <div className="flex flex-col items-center">
            <img
              src={URL.createObjectURL(singleImage)}
              alt="Selected"
              className="w-32 h-28 object-cover mb-4 rounded-lg"
            />
            <button
              type="button"
              onClick={() => setSingleImage(null)}
              className="text-sm text-red-600 hover:text-red-800 underline"
            >
              Remove Image
            </button>
          </div>
        ) : (
          <div className="space-y-2">
            <svg
              className="mx-auto h-12 w-12 text-gray-400"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 48 48"
              aria-hidden="true"
            >
              <path
                d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <p className="text-sm text-gray-600">
              Drag and drop your image here, or click to browse
            </p>
            <p className="text-xs text-gray-500">
              PNG, JPG, GIF up to 10MB
            </p>
          </div>
        )}
        <input
          type="file"
          id="fileInput"
          className="hidden"
          onChange={handleFileChange}
          accept="image/*, .heic, .heif"
        />
        <label
          htmlFor="fileInput"
          className="mt-4 inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          Select File
        </label>
      </div>
    </div>
  </div>

  {/* Form Footer */}
  <div className="px-6 py-4  rounded-b-lg flex justify-start mb-10">
    <button
      type="submit"
      disabled={isLoading}
      className={`inline-flex justify-center py-2 px-6 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ${
        isLoading ? "opacity-75 cursor-not-allowed" : ""
      }`}
    >
      {isLoading ? (
        <>
          <svg
            className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
          Processing...
        </>
      ) : (
        "Create Product"
      )}
    </button>
  </div>
</form>
        </div>
      </div>
    </div>
  );
};

export default AddCustomProductModal;
